import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Compass } from 'lucide-react';

/**
 * QuickHelpPanel — "Not sure where to start?" panel at the bottom of
 * the page. Bridges to the existing AskStewie question flow rather
 * than inventing new AI plumbing.
 */
export default function QuickHelpPanel() {
  const navigate = useNavigate();
  return (
    <aside className="cc-quickhelp" aria-labelledby="cc-quickhelp-title" data-testid="cc-quickhelp">
      <span className="cc-quickhelp-icon" aria-hidden="true">
        <Compass size={22} strokeWidth={2.2} />
      </span>
      <div className="cc-quickhelp-body">
        <h3 id="cc-quickhelp-title" className="cc-quickhelp-title">Need help choosing?</h3>
        <p className="cc-quickhelp-sub">
          Describe what happened and AskStewie will point you at the right tool.
        </p>
      </div>
      <button
        type="button"
        className="cc-quickhelp-btn"
        onClick={() => navigate('/ask-stewie')}
        data-testid="cc-quickhelp-btn"
      >
        Help Me Choose
      </button>
    </aside>
  );
}
